import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { InvoiceFrequencyType } from 'entities/Invoice';
import { Discount } from '../model/types';
import { UnitTypeSetting } from 'entities/RentOption';

interface Params {
  page?: number;
  limit?: number;
  search?: string;
  warehouseId?: string | string[];
  unitName?: string;
  unitType?: UnitTypeSetting;
  periodType?: InvoiceFrequencyType;
  contractDuration?: number;
  unitSize?: number;
  name?: string;
  priority?: number;
  isActive?: boolean;
  orderBy?: string;
}

export const getPaginatedDiscountListingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaginatedDiscountListing: build.query<Pagination<Discount>, Params | void>({
      query: (args) => ({
        url: '/discounts/listing',
        params: args ? { ...args } : undefined,
      }),
      providesTags: ['Discounts'],
    }),
  }),
});

export const { useGetPaginatedDiscountListingQuery } = getPaginatedDiscountListingApi;
